const RESERVATION_LIMIT = [
  { text: 'Unlimited', value: '0' },
  { text: '1', value: '1' },
  { text: '2', value: '2' },
  { text: '3', value: '3' },
  { text: '4', value: '4' },
  { text: '5', value: '5' },
  { text: '6', value: '6' },
  { text: '7', value: '7' },
  { text: '8', value: '8' },
  { text: '9', value: '9' },
  { text: '10', value: '10' },
  { text: '15', value: '15' },
  { text: '20', value: '20' },
  { text: '25', value: '25' },
  { text: '30', value: '30' },
  { text: '35', value: '35' },
  { text: '40', value: '40' },
  { text: '45', value: '45' },
  { text: '50', value: '50' },
  { text: '60', value: '60' },
  { text: '70', value: '70' },
  { text: '80', value: '80' },
  { text: '90', value: '90' },
  { text: '100', value: '100' },
];

export default RESERVATION_LIMIT;



// WEBPACK FOOTER //
// ./src/constants/reservationLimit.js